import { ErrorMessage, Field } from "formik";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import moment from "moment";

export const FormTimeField = ({
    label = "textField",
    labelClassName = "",
    name = "textField",
    value = "",
    onChange = () => {},
    className = "",
    placeholder = "",
    type = "time",
    required,
    ...props
}) => {
    return (
        <div className="w-full max-w-[20rem]">
            <Field name={name}>
                {({ field, meta }) => (
                    <div className={`flex flex-col gap-1 ${className} w-full`}>
                        {label && (
                            <label
                                htmlFor={name}
                                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${labelClassName} ${
                                    meta.touched && meta.error
                                        ? "text-errorColor"
                                        : labelClassName
                                }`}
                            >
                                {formatUnderscoreToSpace(label)}
                            </label>
                        )}
                        <input
                            {...field}
                            {...props}
                            id={name}
                            name={name}
                            type={type}
                            //   value={value}
                            placeholder={placeholder}
                            required={required}
                            className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none ${
                            meta.touched && meta.error
                                ? "border-errorColor"
                                : "border-greyText"
                        }`}
                        />
                        <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                            <ErrorMessage name={name} />
                        </label>
                    </div>
                )}
            </Field>
        </div>
    );
};

export const FormDateField = ({
    label = "textField",
    labelClassName = "",
    name = "textField",
    value = "",
    onChange = () => {},
    className = "",
    placeholder = "",
    type = "date",
    required,
    ...props
}) => {
    return (
        <div className="w-full max-w-[20rem]">
            <Field name={name}>
                {({ field, meta, form }) => (
                    <div className={`flex flex-col gap-1 ${className} w-full`}>
                        {label && (
                            <label
                                htmlFor={name}
                                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${labelClassName} ${
                                    meta.touched && meta.error
                                        ? "text-errorColor"
                                        : labelClassName
                                }`}
                            >
                                {label}
                            </label>
                        )}
                        <input
                            {...field}
                            {...props}
                            id={name}
                            name={name}
                            type={type}
                            //   value={value}
                            placeholder={placeholder}
                            required={required}
                            className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none ${
                            meta.touched && meta.error
                                ? "border-errorColor"
                                : "border-greyText"
                        }`}
                        />
                        <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                            <ErrorMessage name={name} />
                        </label>
                    </div>
                )}
            </Field>
        </div>
    );
};

export const FormDateTimeField = ({
    label = "textField",
    labelClassName = "",
    name = "textField",
    value = "",
    onChange = () => {},
    className = "",
    placeholder = "",
    type = "date",
    required,
    ...props
}) => {
    return (
        <div className="w-full max-w-[20rem]">
            <Field name={name}>
                {({ field, meta, form }) => (
                    <div className={`flex flex-col gap-1 ${className} w-full`}>
                        {label && (
                            <label
                                htmlFor={name}
                                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${labelClassName} ${
                                    meta.touched && meta.error
                                        ? "text-errorColor"
                                        : labelClassName
                                }`}
                            >
                                {label}
                            </label>
                        )}
                        <input
                            {...field}
                            {...props}
                            id={name}
                            name={name}
                            type={type}
                            // onChange={(e) => {
                            //     console.log("e", e.target.value);

                            //     try {
                            //         // Create a Date object from the value
                            //         const utcDate = new Date(e.target.value);

                            //         // IST = UTC + 5:30
                            //         const istOffset = -5.5 * 60;
                            //         const istTime = new Date(
                            //             utcDate.getTime() +
                            //                 istOffset * 60 * 1000
                            //         );
                            //         const date = utcDate;

                            //         var dateFormated = `${moment(date).format("YYYY-MM-DDTHH:MM")}`;
      
                            //         form.setFieldValue(name, dateFormated);
                            //     } catch (error) {
                            //         console.log("formattedTime error", error);
                            //         form.setFieldValue(name, e.target.value);
                            //     }
                            // }}
                            //   value={value}
                            placeholder={placeholder}
                            required={required}
                            className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none ${
                            meta.touched && meta.error
                                ? "border-errorColor"
                                : "border-greyText"
                        }`}
                        />
                        <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                            <ErrorMessage name={name} />
                        </label>
                    </div>
                )}
            </Field>
        </div>
    );
};
